// Mock data for The True Gem clone

export const products = [
  {
    id: 1,
    name: "Alaniz Solitaire Asscher",
    price: 2075,
    image: "https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=800&q=80",
    category: "engagement"
  },
  {
    id: 2,
    name: "Alaniz Solitaire Cushion",
    price: 2075,
    image: "https://images.unsplash.com/photo-1603561596112-0a132b757442?w=800&q=80",
    category: "engagement"
  },
  {
    id: 3,
    name: "Alaniz Solitaire Elongated Cushion",
    price: 2075,
    image: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=800&q=80",
    category: "engagement"
  },
  {
    id: 4,
    name: "Alaniz Solitaire Emerald",
    price: 2075,
    image: "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=800&q=80",
    category: "engagement"
  },
  {
    id: 5,
    name: "Alaniz Solitaire Marquise",
    price: 2075,
    image: "https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=800&q=80",
    category: "engagement"
  },
  {
    id: 6,
    name: "Alaniz Solitaire OMC",
    price: 2075,
    image: "https://images.unsplash.com/photo-1602751584552-8ba73aad10e1?w=800&q=80",
    category: "engagement"
  },
  {
    id: 7,
    name: "Alaniz Solitaire Oval",
    price: 2075,
    image: "https://images.unsplash.com/photo-1606800052052-a08af7148866?w=800&q=80",
    category: "engagement"
  },
  {
    id: 8,
    name: "Alaniz Solitaire Pear",
    price: 2075,
    image: "https://images.unsplash.com/photo-1603561591411-07134e71a2a9?w=800&q=80",
    category: "engagement"
  },
  {
    id: 9,
    name: "Dianne Ring Asscher",
    price: 2275,
    image: "https://images.unsplash.com/photo-1612595985225-f045476d0dc6?w=800&q=80",
    category: "engagement"
  },
  {
    id: 10,
    name: "Dianne Ring Cushion",
    price: 2275,
    image: "https://images.unsplash.com/photo-1603561596112-0a132b757442?w=800&q=80",
    category: "engagement"
  },
  {
    id: 11,
    name: "Taylor Solitaire Oval",
    price: 4395,
    image: "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=800&q=80",
    category: "instock",
    specs: "5.04ct D VS1 Oval Lab Grown Diamond"
  },
  {
    id: 12,
    name: "Charlotte Solitaire Round",
    price: 4850,
    image: "https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=800&q=80",
    category: "instock",
    specs: "2.61ct G VS1 Round Brilliant Lab Grown Diamond"
  },
  {
    id: 13,
    name: "Emalyn Ring Oval",
    price: 5575,
    image: "https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=800&q=80",
    category: "instock",
    specs: "4.04ct D VVS2 Oval Lab Grown Diamond"
  },
  {
    id: 14,
    name: "Michelle Ring Radiant",
    price: 5480,
    image: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=800&q=80",
    category: "instock",
    specs: "5.01ct F VS1 Radiant Lab Grown Diamond"
  },
  {
    id: 15,
    name: "Gwen Ring Emerald",
    price: 6350,
    image: "https://images.unsplash.com/photo-1602751584552-8ba73aad10e1?w=800&q=80",
    category: "instock",
    specs: "3.51ct E VVS2 Antique Emerald Lab Grown Diamond"
  },
  {
    id: 16,
    name: "Sloan Solitaire Round",
    price: 4075,
    image: "https://images.unsplash.com/photo-1606800052052-a08af7148866?w=800&q=80",
    category: "instock",
    specs: "4.53ct E VS1 Round Brilliant Lab Grown Diamond"
  }
];

export const collections = [
  {
    id: 1,
    title: "Engagement Rings",
    image: "https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=800&q=80",
    link: "/collections/engagement-rings"
  },
  {
    id: 2,
    title: "Unisex Bands",
    image: "https://images.unsplash.com/photo-1603561596112-0a132b757442?w=800&q=80",
    link: "/collections/wedding"
  },
  {
    id: 3,
    title: "Lifestyle",
    image: "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=800&q=80",
    link: "/collections/lifestyle"
  },
  {
    id: 4,
    title: "True Gem Vault Collection",
    image: "https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=800&q=80",
    link: "/collections/vault"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Callie",
    text: "My custom ring is a work of art. I am completely obsessed with it, and it only makes it more meaningful that no one was harmed or exploited in its construction."
  },
  {
    id: 2,
    name: "Samuel",
    text: "The design and quality of the rings are what brought us to DQ the Master Jeweler, their kindness and customer service are the reasons I would pick DQ the Master Jeweler over and over again!"
  },
  {
    id: 3,
    name: "Cassidy",
    text: "I am so happy I decided to go with DQ the Master Jeweler and will not hesitate to recommend them to people. The entire experience was wonderful and the ring is out of this world!"
  },
  {
    id: 4,
    name: "Karin",
    text: "I love everything this company stands for and most important of all, I love, love, love my ring and I'm sold on Moissanite! It has so much fire and light!"
  },
  {
    id: 5,
    name: "Madison",
    text: "My ring arrived to Canada safely and quickly. I would highly recommend DQ the Master Jeweler over and over again! They make stunning pieces with quality materials."
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "How the New Tariffs May Impact Diamond Sourcing",
    excerpt: "As the effects of the newly announced tariffs begin to take shape, we want to keep you informed about how this may impact your purchasing process and what steps we are taking to support you during this time.",
    link: "/blog/tariffs-diamond-sourcing"
  },
  {
    id: 2,
    title: "You Are The Light Giveaway!",
    excerpt: "This giveaway is more than a chance to receive something beautiful. It is a love note, a reminder, a small offering to say: You are the light. And no one, and nothing, can take that light away from you.",
    link: "/blog/light-giveaway"
  },
  {
    id: 3,
    title: "New Drops to Love for Valentine's Day!",
    excerpt: "Introducing Diamond Q Jewelers' New Lifestyle Jewelry Collection: Part Two. This year, we are thrilled to introduce the second installment of our lifestyle jewelry collection, curated in collaboration with our trusted manufacturing partners.",
    link: "/blog/valentines-new-drops"
  }
];